import { render } from "./Quest.vue?vue&type=template&id=ef359424"
import script from "./Quest.vue?vue&type=script&lang=js"
export * from "./Quest.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__